import List from "@/components/list";
import router from "@/router";
import Bus from "./Bus.js";
import "./table.scss";

const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function () { };
  const isShowBtn = args.props.isShowBtn;

  function handleDelete(vo) {
    Bus.$emit("deleteLiveRoom", vo.row);
  }
  function handleEdit(data) {
    router.push({
      path: "liveManage/add",
      query: {
        id: data.row.uuid,
      },
    });
  }
  function showImage(vo) {
    Bus.$emit("showImg", vo.row);
  }
  function setDown(data, type) {
    Bus.$emit("setDown", { id: data, status: type });
  }
  function setUp(data, type) {
    Bus.$emit("setDown", { id: data, status: type });
  }

  function toDetail(item) {
    router.push({
      path: "liveManage/detail",
      query: {
        id: item.uuid,
      },
    });
  }
  // 直播间管理-管理
  function goLiveRoomManage(vo) {
    const item = vo.row;
    router.push({
      path: "liveManage/liveRoomManage",
      query: {
        liveRoomId: item.uuid
      },
    });
  }

  const Deal = ({ props: { vo } }) => {
    let dealConf = [];
    // 上线
    if (vo.row.onlineStatus == 1) {
      dealConf.push(["icon-edit-disable", "编辑", () => { }, "liveManage:update"]);
      dealConf.push([
        "icon-down",
        "下线",
        () => setDown(vo.row.uuid, 0),
        "liveManage:online"
      ]);
      dealConf.push([
        "icon-delete-disable",
        "删除",
        () => {
          return;
        },
        "liveManage:delete"
      ])
    } else {
      // 下线
      // 直播中合已结束不能编辑
      if (vo.row.status && vo.row.status > 1) {
        dealConf.push(["icon-edit-disable", "编辑", () => { }, "liveManage:update"]);
      } else {
        dealConf.push(["icon-edit", "编辑", () => handleEdit(vo), "liveManage:update"])
      }
      dealConf.push([
        "icon-up",
        "上线",
        () => setUp(vo.row.uuid, 1),
        "liveManage:online"
      ]);
      dealConf.push(["icon-delete", "删除", () => handleDelete(vo), "liveManage:delete"]);
    }
    dealConf.push(["iconfont icguanli_sel iconfont-adapt", "管理", () => goLiveRoomManage(vo), "liveManage:manage"])
    // v-permission={item[2]}
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const LiveName = ({ props: { vo } }) => {
    const item = vo.row;
    return (
      <span
        class="live-name"
        onClick={() => {
          toDetail(item);
        }}
      >
        {item.name}
      </span>
    );
  };

  const Img = ({ props: { vo } }) => {
    return (
      <div onClick={() => showImage(vo)}>
        <img
          class='live-image'
          src={
            vo.row.coverUrl
          }
        />
      </div>
    );
  };

  const Status = ({ props: { vo } }) => {
    const item = vo.row;
    let dotClass = 'gray_dot';
    let statusClass = '';
    switch (item.statusName) {
      case '直播中':{
        dotClass = 'blue_dot'
        statusClass = 'status_blue'
        break;
      }
      case '已结束':{
        dotClass = 'end_dot'
        statusClass = 'end_text'
        break;
      }
      default:
        break;
    }
    return (
      <div>
        {
          item.statusName ? (
            <div class='status_content' >
              {
                item.statusName && item.statusName != '--' ? (
                  <div class={dotClass}/>
                ) : null
              }
              <div class={statusClass}>{item.statusName}</div>
            </div>
          ) : null
        }
        
        <div>{item.onlineStatusName}</div>
      </div>
    )
  };

  const LiveTime = ({ props: { vo } }) => {
    const item = vo.row;
    return (
      <div>
        <div>{item.startDateStr}</div>
        <div>{item.endDateStr}</div>
      </div>
    )
  };

  const AccountTableConfig = [
    // {
    //   type: "selection",
    //   label: "main"
    // },
    {
      label: "直播名称",
      minWidth: "200",
      showOverflowTooltip: true,
      render: vo => <LiveName vo={vo} />
    },
    {
      label: "封面",
      width: "190",
      render: vo => <Img vo={vo} />
    },
    
    {
      label: "直播时间",
      prop: "liveTime",
      width: "140",
      render: vo => <LiveTime vo={vo} />
    },
    {
      label: "状态",
      width: "100",
      render: vo => <Status vo={vo} />
    },
    {
      label: "回放视频",
      prop: "bizName",
      minWidth: "180",
      showOverflowTooltip: true,
    },
    {
      label: "展示终端",
      prop: "displayTypeName",
      width: "120"
    },
    
    {
      label: "创建时间",
      prop: "createDate",
      width: "160",
    },
    
    {
      label: "操作",
      width: "150",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];
  if (isShowBtn) {
    AccountTableConfig.splice(1, 0, {
      label: "所属学院",
      prop: "deptName",
      minWidth: "140",
      showOverflowTooltip: true,
    });
  }

  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
